import React from 'react'
import styled from 'styled-components'
import Container from '../Components/Container'
import Project from '../Components/Project'
import { _projects } from '../Data/projects'

const Projects = () => (
  <Container>
    <Wrapper>
      <List>
        {_projects.map(({ id, title, image, link }) => (
          <Project key={id} name={title} image={image} link={link} />
        ))}
      </List>
    </Wrapper>
  </Container>
)

const Wrapper = styled.div`
  margin-top: 88px;
`

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
`

export default Projects
